import { Painting } from "./painting";
import { Environment } from "../../environments/environment";

export interface ImageSetItem {
  srcSet: string;
  type: string;
}

export interface GalleryImage {
  original: string;
  thumbnail: string;
  description?: string;
  imageSet: ImageSetItem[];
}

export class ImageHelper {
  private static LANDSCAPE_WIDTHS: number[] = [
    640, 750, 828, 1136, 1334, 1536, 1668, 1792, 2048, 2224, 2672,
  ];
  private static PORTRAIT_WIDTHS: number[] = [
    640, 750, 828, 1136, 1334, 1536, 1668, 1792,
  ];

  private static ONE_DAY = 1000 * 60 * 60 * 24;

  public static createGalleryImage(painting: Painting): GalleryImage {
    let original = this.createUrl(painting.numero, "1536");
    let thumbnail = this.createUrl(painting.numero, "t");
    let description = painting?.description;
    let imageSet: ImageSetItem[] = [];
    imageSet.push(this.createImageSetItem(painting));
    return {
      original: original,
      thumbnail: thumbnail,
      description: description,
      imageSet: imageSet,
    };
  }

  public static createSrcSetWithOrientation(painting: Painting) {
    let srcSet: any[] = [];
    let widths =
      painting.orientation !== "P"
        ? this.LANDSCAPE_WIDTHS
        : this.PORTRAIT_WIDTHS;
    for (const width of widths) {
      let url = this.createUrl(painting.numero, width.toString());
      srcSet.push(`${url} ${width}w`);
    }
    return srcSet.join(", ");
  }

  public static dayNumber() {
    let now = new Date();
    let start = new Date(now.getFullYear(), 0, 0);
    let diff =
      now.getTime() -
      start.getTime() +
      (start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000;
    return Math.floor(diff / this.ONE_DAY);
  }

  /* -------------------------------------------------------------------------------------------
                                      PRIVATE
       ------------------------------------------------------------------------------------------- */

  private static createImageSetItem(painting: Painting) {
    let srcSet = this.createSrcSetWithOrientation(painting);
    let typeImage = `image/webp`;
    return {
      srcSet: srcSet,
      type: typeImage,
    };
  }

  private static createUrl(numero: string, width: string) {
    return `${Environment.getBaseUrl()}/img/${numero}/${numero}_${width}.webp`;
  }
}
